import React from "react";

/**
 * Component สำหรับการ Redirect Link ไปยังเว็บไซต์มหาวิทยาลัย Version เก่า
 */
class OldSiteRedirect extends React.Component
{
    constructor(props)
    {
        // ที่อยู่ของเว็บไซต์มหาวิทยาลัยเดิม
        const base = "http://developers.nsru.ac.th/histories/P11_NSRU/2017";

        // สร้าง URI โดยอิงกับ Params เดิม
        var url = base
        if(props.match.params.lang !== undefined) url += '/' + props.match.params.lang
        if(props.match.params.one !== undefined) url += '/' + props.match.params.one
        if(props.match.params.two !== undefined) url += '/' + props.match.params.two
        if(props.match.params.three !== undefined) url += '/' + props.match.params.three

        // Redirect ไปยังเว็บไซต์เดิม
        window.location.href = url;
        super();
    }

    render() {
        return (
            <>
            </>
        )
    }
}

export default OldSiteRedirect;
